import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { isNull } from 'lodash'
import { parseQ, itemLink, getLocationKey, isOnMobile } from '../utils'
import { themeColors } from '../styles/theme'
import {
  getItems,
  canLoadMoreItems,
  getItemsLoading,
  getTotalItems,
  getDistrictFilter,
} from '../selectors'
import {
  loadItems,
  loadMoreItems,
  putItemsInCache,
  unloadItems,
  iWant,
  iWantNot,
} from '../actions'
import NoResults from '../common/NoResults'
import ObjectCard from '../common/ObjectCard'
import ObjectCardVirtual from '../common/ObjectCardVirtual'

class AllWorlds extends PureComponent {
  componentDidMount() {
    this.props.topBarSetTitle('Tutti i mondi')
    this.props.loadItems(
      {
        district_id: this.props.districtFilter,
        q: this.props.searchString,
      },
      getLocationKey(this.props.location)
    )
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.searchString !== nextProps.searchString ||
      this.props.districtFilter !== nextProps.districtFilter
    ) {
      this.props.unloadItems()
      this.props.loadItems({
        district_id: nextProps.districtFilter,
        q: nextProps.searchString,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadItems(false)
  }

  loadMore = () => {
    this.props.loadMoreItems({
      district_id: this.props.districtFilter,
      q: this.props.searchString,
    })
  }

  goToItemDetail = item => {
    this.props.putItemsInCache({
      cacheKey: getLocationKey(this.props.location),
    })
    this.props.history.push(itemLink(item))
  }

  render() {
    const {
      user,
      loading,
      items,
      canLoadMoreItems,
      searchString,
      districtFilter,
      wantedLoadingById,
      iWant,
      iWantNot,
    } = this.props

    return (
      <div>
        <ObjectCardVirtual
          items={items}
          reRenderFor={{ wantedLoadingById }}
          loadMore={this.loadMore}
          canLoadMoreItems={canLoadMoreItems}
          loading={loading}
          noContentRenderer={() => (
            <div>
              {!loading &&
                !isNull(items) && (
                  <NoResults>
                    {searchString === '' &&
                      districtFilter === '' && <span>Nessun oggetto</span>}
                    {(searchString !== '' || districtFilter !== '') && (
                      <span>
                        Nessun oggetto per la ricerca
                        {searchString !== '' && (
                          <span>
                            {' '}
                            <b>
                              <i>{searchString}</i>
                            </b>
                          </span>
                        )}
                      </span>
                    )}
                  </NoResults>
                )}
            </div>
          )}
          renderObjectCard={item => {
            if (user) {
              return (
                <ObjectCard
                  item={item}
                  onClick={this.goToItemDetail}
                  wantedLoading={wantedLoadingById[item.id]}
                  withAttributeLinks
                  iWant={iWant}
                  iWantNot={iWantNot}
                />
              )
            } else {
              return (
                <ObjectCard
                  item={item}
                  onClick={this.goToItemDetail}
                  withAttributeLinks
                />
              )
            }
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user,
    searchString: parseQ(ownProps.location),
    districtFilter: getDistrictFilter(state, ownProps.location),
    items: getItems(state, getLocationKey(state)),
    totalItems: getTotalItems(state),
    canLoadMoreItems: canLoadMoreItems(state),
    loading: getItemsLoading(state),
    wantedLoadingById: state.allItems.wantedLoadingById,
  }
}

export default connect(mapStateToProps, {
  loadItems,
  loadMoreItems,
  putItemsInCache,
  unloadItems,
  iWant,
  iWantNot,
})(AllWorlds)



// WEBPACK FOOTER //
// ./src/pages/AllWorlds.js